import { ApiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRequest, ApiCertificazioneIdCertificazioneLogAnagrafeCedacriGetRequest, CertificazioneApi, CertificazioneEmailApi, CertificazioneEmailDto, Configuration, DettaglioCertificazioneDto, DettaglioCertificazioneEmailDto, LogCertificazioneAnagrafeCedacriDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';

export const getCertificazioneEmail = createAsyncThunk<DettaglioCertificazioneEmailDto | undefined, number, ThunkApiConfig>(
  'certificazioneEmail/getCertificaContatto', async (idCertificazioneEmail, { dispatch, extra, getState }) => {
    try {

      if (extra.mock) {
        // return (await import('../mock/get-certificazione-email.json')).default;
      } else {
        return await new CertificazioneEmailApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneEmailIdCertificazioneEmailDettaglioGet({ idCertificazioneEmail });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getDettaglioCertificazione = createAsyncThunk<DettaglioCertificazioneDto | void, number, ThunkApiConfig>(
  'certificazione/getDettaglioCertificazione', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return {
        };
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneIdDettaglioGet({ id });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
export const getAvvioCertificazione = createAsyncThunk<CertificazioneEmailDto | void, number, ThunkApiConfig>(
  'certificazione/getAvvioCertificazione', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return {

        };
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneIdAvvioGet({ id });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const inviaEmail = createAsyncThunk<CertificazioneEmailDto | undefined, number, ThunkApiConfig>(
  'certificazione/inviaEmail', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/post-ricerca-processi.json')).default;
      } else {
        const request: ApiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRequest = {
          idCertificazioneEmail: id
        }
        return await new CertificazioneEmailApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneEmailIdCertificazioneEmailInviaEmailGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
export const resetResultInvioMail = createAction<void, 'resetResultInvioMail'>('resetResultInvioMail');


export const getLogCedcri = createAsyncThunk<LogCertificazioneAnagrafeCedacriDto[] | undefined, number, ThunkApiConfig>(
  'certificazione/getLogCedcri', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/post-ricerca-processi.json')).default;
      } else {
        const request: ApiCertificazioneIdCertificazioneLogAnagrafeCedacriGetRequest = {
          idCertificazione: id
        }
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneIdCertificazioneLogAnagrafeCedacriGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const resetResultAvvioCertificazione = createAction<void, 'resetResultAvvioCertificazione'>('resetResultAvvioCertificazione');
